const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {		
			ZZ_TRANSPAKCORP: {
				name: ['(客製)薪資', '(客製)薪資', '(客製)薪資'],
				children: {
					ZZ_TRANSPAKCORP_PB40130: {
						name: ['(客製)加班加發計算作業', '(客製)加班加發計算作業', '(客製)加班加發計算作業'],
						url: '/zz_transpakcorp_pb40130',
						hint: [],
					},
				},
			},
			ZZ_TRANSPAKCORP_2: {
				name: ['(客製)出勤', '(客製)出勤', '(客製)出勤'],
				children: {
					ZZ_TRANSPAKCORP_SIM_JOB: {
						name: ['(客製)出勤模擬試算(C報表)', '(客製)出勤模擬試算(C報表)', '(客製)出勤模擬試算(C報表)'],
						url: '/zz_transpakcorp_sim_job',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};